import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const AnalysisOfRecursiveNonRecursive = () => (
  <QPhototModuleSubtopic
    title="Analysis of non-recursive and recursive algorithms"
    videos={[
      "https://www.youtube.com/embed/8SsFoswOArQ"
    ]}
    takeaways={[
      { text: "go through the above video clearly, mostly numerical question asked from this topic." }
    ]}
    questions={[
      { text: "Evaluate the Asymptotic recurrence relation for the given function",
        image:"/dsa_2.png"
       }
    ]}
    exampleVideos={[]}
  />
);

export default AnalysisOfRecursiveNonRecursive;
